/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
    Table, message, Button, Typography, Modal, Progress, Tag, Empty, Alert, Tooltip, DatePicker, Input, Select, Space, Collapse, Descriptions, List, Divider, Rate,
} from 'antd';
import {
    SoundOutlined, CheckCircleOutlined, LoadingOutlined, CheckOutlined, CloseOutlined, WarningOutlined,
    ProfileOutlined, FileTextOutlined, AlignLeftOutlined, TeamOutlined, AuditOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import randomId from '../../../../../../../../logic/utils/randomId';

const STAGE_LABELS = {
    download: 'Скачивание файла',
    queued: 'В очереди на обработку',
    processing: 'Обработка',
    transcription: 'Распознавание текста',
    diarization: 'Разбиение по спикерам',
    context: 'Определение контекста',
    llm_analysis: 'Анализ содержимого',
    speaker_roles: 'Определение ролей спикеров',
    saving: 'Сохранение результата',
    completed: 'Готово',
};

const stageLabel = (stage) => STAGE_LABELS[stage] || stage || 'Обработка...';

// Стиль пузыря диалога по роли/спикеру
const speakerStyle = (seg) => {
    if (seg.role === 'Operator') {
        return {
            align: 'flex-start', bg: '#e6f4ff', border: '#1677ff', label: 'Оператор',
        };
    }
    if (seg.role === 'Client') {
        return {
            align: 'flex-end', bg: '#f6ffed', border: '#52c41a', label: 'Клиент',
        };
    }
    return {
        align: 'flex-start', bg: '#fafafa', border: '#bfbfbf', label: seg.speaker || 'Участник',
    };
};

const formatSec = (s) => {
    if (s == null) return '';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec < 10 ? '0' : ''}${sec}`;
};

const parseAudio = (audio) => {
    if (!audio) return <span>Записи нет</span>;
    const audioArr = audio.split(',');
    return audioArr.map((record, idx) => {
        const audioPath = record.split('/');
        const src = `/records/${audioPath[audioPath.length - 1]}`;
        // eslint-disable-next-line jsx-a11y/media-has-caption
        return <audio key={randomId()} src={src} controls style={idx !== 0 ? { marginTop: '10px' } : {}} />;
    });
};


const renderRichText = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, i) => {
        if (!line.trim()) return <div key={i} style={{ height: 6 }} />;
        const parts = line.split(/(\*\*[^*]+\*\*)/g);
        return (
            <p key={i} style={{ margin: '0 0 8px' }}>
                {parts.map((p, j) => {
                    if (p.startsWith('**') && p.endsWith('**')) {
                        return <strong key={j}>{p.slice(2, -2)}</strong>;
                    }
                    return <span key={j}>{p}</span>;
                })}
            </p>
        );
    });
};

const scoreColor = (score) => {
    if (score >= 80) return '#2a2';
    if (score >= 50) return '#a80';
    return '#c00';
};

function RecognitionReportLegacy({ data, record }) {
    const summaryBrief = (data.summary_brief && data.summary_brief.success) ? data.summary_brief.content : '';
    const summaryDetailed = (data.summary_detailed && data.summary_detailed.success) ? data.summary_detailed.content : '';
    const transcription = data.transcription || {};
    const diaSegments = transcription.segments_with_speakers || (data.diarization && data.diarization.segments) || [];
    const scriptCheck = data.script_check || {};
    const dangerCheck = data.danger_check || {};
    const dangerIncidents = dangerCheck.incidents || [];
    const meta = data.metadata || {};
    const processingTime = data.processing_time || meta.processing_time;
    const topic = data.meeting_topic || meta.meeting_topic;

    return (
        <div>
            <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: 14, marginBottom: 16 }}>
                <Typography.Title level={4} style={{ marginBottom: 6 }}>
                    {topic || 'Распознавание разговора'}
                </Typography.Title>
                <Descriptions size="small" column={2} colon>
                    {record.ticket_number && (
                        <Descriptions.Item label="Талон">№{record.ticket_number}</Descriptions.Item>
                    )}
                    {record.user_fio && (
                        <Descriptions.Item label="Оператор">{record.user_fio}</Descriptions.Item>
                    )}
                    {record.queue_name && (
                        <Descriptions.Item label="Услуга">{record.queue_name}</Descriptions.Item>
                    )}
                    {record.close_data && (
                        <Descriptions.Item label="Дата">{record.close_data}</Descriptions.Item>
                    )}
                    {record.total_proc_time && (
                        <Descriptions.Item label="Длительность обслуживания">{record.total_proc_time}</Descriptions.Item>
                    )}
                    <Descriptions.Item label="Оценка клиента">
                        {record.ticket_mark > 0
                            ? <Rate disabled value={Number(record.ticket_mark)} />
                            : <Typography.Text type="secondary">Оценка не проставлена</Typography.Text>}
                    </Descriptions.Item>
                    {meta.num_speakers > 0 && (
                        <Descriptions.Item label="Спикеров">{meta.num_speakers}</Descriptions.Item>
                    )}
                </Descriptions>
                <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                    <Tag color="green">Распознано</Tag>
                    {scriptCheck.script_used && (
                        <Tag color={scriptCheck.score >= 80 ? 'green' : (scriptCheck.score >= 50 ? 'orange' : 'red')}>
                            Скрипт: {scriptCheck.score}/100
                        </Tag>
                    )}
                    {dangerCheck.has_danger && dangerCheck.danger_count > 0 && (
                        <Tag color="red" icon={<WarningOutlined />}>
                            Опасных моментов: {dangerCheck.danger_count}
                        </Tag>
                    )}
                    {processingTime && (
                        <Tag>Обработано за {Math.round(processingTime)} сек</Tag>
                    )}
                </div>
            </div>

            <div style={{
                border: '1px solid #e0e0e0', borderRadius: 6, padding: 12, marginBottom: 16, background: '#fafafa',
            }}
            >
                <div style={{ fontWeight: 600, marginBottom: 8 }}>Аудиозапись</div>
                {parseAudio(record.audio)}
            </div>

            <Collapse defaultActiveKey={['brief']} expandIconPosition="end">
                <Collapse.Panel header="Краткое резюме" key="brief">
                    {summaryBrief ? (
                        <div style={{ fontSize: 13, lineHeight: 1.7 }}>{renderRichText(summaryBrief)}</div>
                    ) : <Empty description="Нет данных" />}
                </Collapse.Panel>

                <Collapse.Panel header="Подробное резюме" key="detailed">
                    {summaryDetailed ? (
                        <div style={{ fontSize: 13, lineHeight: 1.7 }}>{renderRichText(summaryDetailed)}</div>
                    ) : <Empty description="Нет данных" />}
                </Collapse.Panel>

                <Collapse.Panel header="Транскрипция" key="transcript">
                    {transcription.text ? (
                        <Typography.Paragraph style={{
                            fontSize: 13, lineHeight: 1.8, whiteSpace: 'pre-wrap', maxHeight: 400, overflow: 'auto', marginBottom: 0,
                        }}
                        >
                            {transcription.text}
                        </Typography.Paragraph>
                    ) : <Empty description="Текст не распознан" />}
                </Collapse.Panel>

                <Collapse.Panel
                    header={`Диаризация${diaSegments.length ? ` (${diaSegments.length} сегм.)` : ''}`}
                    key="diarization"
                >
                    {diaSegments.length > 0 ? (
                        <div style={{ maxHeight: 450, overflow: 'auto' }}>
                            {diaSegments.map((seg, idx) => {
                                const s = speakerStyle(seg);
                                const isDanger = dangerIncidents.some((inc) => (
                                    inc && typeof inc.start === 'number'
                                    && inc.start >= seg.start && inc.start <= seg.end
                                ));
                                return (
                                    <div
                                        key={idx}
                                        style={{
                                            display: 'flex',
                                            gap: 10,
                                            padding: '6px 8px',
                                            borderBottom: '1px solid #efefef',
                                            background: isDanger ? '#fff2f0' : 'transparent',
                                        }}
                                    >
                                        <div style={{
                                            fontFamily: 'monospace', fontSize: 11, color: '#999', minWidth: 90, paddingTop: 2,
                                        }}
                                        >
                                            {formatSec(seg.start)} – {formatSec(seg.end)}
                                        </div>
                                        <div style={{
                                            fontWeight: 600, fontSize: 12, color: s.border, minWidth: 90, paddingTop: 2,
                                        }}
                                        >
                                            {s.label}
                                        </div>
                                        <div style={{ flex: 1, fontSize: 13, lineHeight: 1.6 }}>
                                            {seg.text}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : <Empty description="Диалог не распознан" />}
                </Collapse.Panel>

                <Collapse.Panel
                    header={`Оценка по скрипту${scriptCheck.script_used ? ` — ${scriptCheck.score}/100` : ''}`}
                    key="script"
                >
                    {scriptCheck.script_used ? (
                        <div>
                            <div style={{
                                display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12,
                            }}
                            >
                                <div style={{
                                    fontSize: 28, fontWeight: 700, color: scoreColor(scriptCheck.score),
                                }}
                                >
                                    {scriptCheck.score}/100
                                </div>
                                {scriptCheck.script_name && (
                                    <Tag>Скрипт: {scriptCheck.script_name}</Tag>
                                )}
                            </div>
                            {scriptCheck.analysis && (
                                <Typography.Paragraph type="secondary">
                                    {scriptCheck.analysis}
                                </Typography.Paragraph>
                            )}
                            {(scriptCheck.completed_stages || []).length > 0 && (
                                <>
                                    <Divider style={{ margin: '12px 0 8px' }} orientation="left" orientationMargin={0}>
                                        Пройденные этапы
                                    </Divider>
                                    <List
                                        size="small"
                                        dataSource={scriptCheck.completed_stages}
                                        renderItem={(item) => (
                                            <List.Item style={{ padding: '4px 0', border: 'none' }}>
                                                <CheckOutlined style={{ color: '#2a2', marginRight: 8 }} />
                                                {item}
                                            </List.Item>
                                        )}
                                    />
                                </>
                            )}
                            {(scriptCheck.missed_stages || []).length > 0 && (
                                <>
                                    <Divider style={{ margin: '12px 0 8px' }} orientation="left" orientationMargin={0}>
                                        Пропущенные этапы
                                    </Divider>
                                    <List
                                        size="small"
                                        dataSource={scriptCheck.missed_stages}
                                        renderItem={(item) => (
                                            <List.Item style={{ padding: '4px 0', border: 'none' }}>
                                                <CloseOutlined style={{ color: '#c00', marginRight: 8 }} />
                                                {item}
                                            </List.Item>
                                        )}
                                    />
                                </>
                            )}
                            {(scriptCheck.recommendations || []).length > 0 && (
                                <>
                                    <Divider style={{ margin: '12px 0 8px' }} orientation="left" orientationMargin={0}>
                                        Рекомендации
                                    </Divider>
                                    <ul style={{ paddingLeft: 18, fontSize: 13, color: '#555' }}>
                                        {scriptCheck.recommendations.map((r, i) => (
                                            <li key={i} style={{ marginBottom: 4 }}>{r}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    ) : <Empty description="Проверка по скрипту не выполнялась" />}
                </Collapse.Panel>

                <Collapse.Panel
                    header={(
                        <span style={{ color: dangerCheck.has_danger ? '#cf1322' : undefined }}>
                            {dangerCheck.has_danger ? <WarningOutlined style={{ marginRight: 6 }} /> : null}
                            Опасные моменты{dangerCheck.danger_count ? ` (${dangerCheck.danger_count})` : ''}
                        </span>
                    )}
                    key="danger"
                >
                    {dangerIncidents.length > 0 ? (
                        <div>
                            {dangerIncidents.map((inc, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        padding: '10px 12px',
                                        background: '#fff2f0',
                                        border: '1px solid #ffccc7',
                                        borderRadius: 6,
                                        borderLeft: `3px solid ${inc.severity === 'medium' ? '#fa8c16' : '#cf1322'}`,
                                        marginBottom: 8,
                                    }}
                                >
                                    <div style={{
                                        display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 4,
                                    }}
                                    >
                                        {inc.category && (
                                            <Tag color={inc.severity === 'medium' ? 'orange' : 'red'}>{inc.category}</Tag>
                                        )}
                                        {typeof inc.start === 'number' && (
                                            <span style={{ fontSize: 11, color: '#999' }}>{formatSec(inc.start)}</span>
                                        )}
                                        {inc.speaker && (
                                            <span style={{ fontSize: 11 }}>{inc.speaker}</span>
                                        )}
                                    </div>
                                    {inc.quote && (
                                        <div style={{
                                            fontSize: 13,
                                            fontStyle: 'italic',
                                            background: '#fff1f0',
                                            padding: '6px 10px',
                                            borderRadius: 4,
                                            margin: '6px 0 4px',
                                        }}
                                        >
                                            «{inc.quote}»
                                        </div>
                                    )}
                                    {(inc.context || inc.recommendation || inc.description) && (
                                        <div style={{ fontSize: 12, color: '#555' }}>
                                            {inc.description || inc.context || inc.recommendation}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : <Empty description="Опасных моментов не обнаружено" />}
                </Collapse.Panel>
            </Collapse>
        </div>
    );
}

const SECTION_DEFS = [
    { key: 'brief', Icon: ProfileOutlined, label: 'Краткое резюме' },
    { key: 'detailed', Icon: FileTextOutlined, label: 'Подробное резюме' },
    { key: 'transcript', Icon: AlignLeftOutlined, label: 'Транскрипция' },
    { key: 'dia', Icon: TeamOutlined, label: 'Диаризация' },
    { key: 'script', Icon: AuditOutlined, label: 'Оценка скрипта' },
    { key: 'danger', Icon: WarningOutlined, label: 'Опасные моменты' },
];

function RecognitionReport({ data, record }) {
    const [activeKey, setActiveKey] = useState('brief');

    const summaryBrief = (data.summary_brief && data.summary_brief.success) ? data.summary_brief.content : '';
    const summaryDetailed = (data.summary_detailed && data.summary_detailed.success) ? data.summary_detailed.content : '';
    const transcription = data.transcription || {};
    const diaSegments = transcription.segments_with_speakers || (data.diarization && data.diarization.segments) || [];
    const scriptCheck = data.script_check || {};
    const dangerCheck = data.danger_check || {};
    const dangerIncidents = dangerCheck.incidents || [];
    const meta = data.metadata || {};
    const topic = data.meeting_topic || meta.meeting_topic;

    const badges = {
        dia: diaSegments.length || null,
        script: scriptCheck.script_used ? scriptCheck.score : null,
        danger: dangerCheck.danger_count || null,
    };

    const badgeTone = {
        dia: 'gray',
        script: scriptCheck.score >= 80 ? 'green' : (scriptCheck.score >= 50 ? 'orange' : 'red'),
        danger: 'red',
    };

    const styles = {
        header: { padding: '22px 28px 18px', borderBottom: '1px solid #f0f0f0' },
        title: { fontSize: 20, fontWeight: 600, marginBottom: 12 },
        meta: {
            display: 'flex', gap: 18, flexWrap: 'wrap', fontSize: 13, color: '#6e6e73', marginBottom: 14,
        },
        statsGrid: {
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginTop: 14,
        },
        statCard: { background: '#fafafa', borderRadius: 10, padding: '12px 14px' },
        statLabel: {
            fontSize: 11, textTransform: 'uppercase', color: '#999', letterSpacing: 0.5, marginBottom: 4, fontWeight: 600,
        },
        statValue: { fontSize: 22, fontWeight: 700, lineHeight: 1.2 },
        audioBar: {
            padding: '14px 28px', background: '#f9fafb', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 14,
        },
        audioLabel: {
            fontSize: 13, color: '#6e6e73', fontWeight: 500, minWidth: 90,
        },
        body: { display: 'flex', minHeight: 540 },
        sidebar: {
            width: 240, background: '#fafafa', borderRight: '1px solid #f0f0f0', padding: '16px 12px',
        },
        content: {
            flex: 1, padding: '24px 28px', overflowY: 'auto', maxHeight: 540,
        },
        sectionTitle: { fontSize: 18, fontWeight: 600, marginBottom: 16 },
    };

    const navItemStyle = (key) => ({
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        padding: '10px 12px',
        borderRadius: 8,
        cursor: 'pointer',
        marginBottom: 4,
        fontSize: 14,
        color: activeKey === key ? '#fff' : '#595959',
        background: activeKey === key ? '#1677ff' : 'transparent',
        boxShadow: activeKey === key ? '0 1px 3px rgba(22,119,255,0.3)' : 'none',
        userSelect: 'none',
        transition: 'all 0.15s',
    });

    const badgeStyle = (key, isActive) => {
        const tone = badgeTone[key];
        if (isActive) {
            return {
                background: 'rgba(255,255,255,0.25)', color: '#fff', fontWeight: 600, fontSize: 11, padding: '1px 8px', borderRadius: 100,
            };
        }
        const tones = {
            green: { bg: '#f6ffed', color: '#389e0d' },
            orange: { bg: '#fff7e6', color: '#d46b08' },
            red: { bg: '#fff1f0', color: '#cf1322' },
            gray: { bg: '#f0f0f0', color: '#595959' },
        };
        const t = tones[tone] || tones.gray;
        return {
            background: t.bg, color: t.color, fontWeight: 600, fontSize: 11, padding: '1px 8px', borderRadius: 100,
        };
    };

    const renderBrief = () => (summaryBrief ? (
        <div style={{ fontSize: 14, lineHeight: 1.75 }}>{renderRichText(summaryBrief)}</div>
    ) : <Empty description="Нет данных" />);

    const renderDetailed = () => (summaryDetailed ? (
        <div style={{ fontSize: 14, lineHeight: 1.75 }}>{renderRichText(summaryDetailed)}</div>
    ) : <Empty description="Нет данных" />);

    const renderTranscript = () => (transcription.text ? (
        <div style={{
            fontSize: 14, lineHeight: 1.8, whiteSpace: 'pre-wrap', color: '#1d1d1f',
        }}
        >
            {transcription.text}
        </div>
    ) : <Empty description="Текст не распознан" />);

    const renderDia = () => (diaSegments.length > 0 ? (
        <div>
            {diaSegments.map((seg, idx) => {
                const s = speakerStyle(seg);
                const isDanger = dangerIncidents.some((inc) => (
                    inc && typeof inc.start === 'number'
                    && inc.start >= seg.start && inc.start <= seg.end
                ));
                return (
                    <div
                        key={idx}
                        style={{
                            display: 'flex',
                            gap: 14,
                            padding: '10px 12px',
                            borderRadius: 10,
                            marginBottom: 6,
                            fontSize: 13,
                            alignItems: 'flex-start',
                            background: isDanger ? '#fff5f5' : 'transparent',
                        }}
                    >
                        <div style={{
                            fontFamily: 'SF Mono, Consolas, monospace', fontSize: 11, color: '#999', minWidth: 80, paddingTop: 2,
                        }}
                        >
                            {formatSec(seg.start)}–{formatSec(seg.end)}
                        </div>
                        <div style={{
                            fontWeight: 600, fontSize: 12, color: s.border, minWidth: 80, paddingTop: 2,
                        }}
                        >
                            {s.label}
                        </div>
                        <div style={{ flex: 1, fontSize: 13, lineHeight: 1.6, color: '#1d1d1f' }}>
                            {seg.text}
                        </div>
                    </div>
                );
            })}
        </div>
    ) : <Empty description="Диалог не распознан" />);

    const renderScript = () => {
        if (!scriptCheck.script_used) return <Empty description="Проверка по скрипту не выполнялась" />;
        const score = scriptCheck.score || 0;
        const scoreToneColor = score >= 80 ? '#389e0d' : (score >= 50 ? '#d46b08' : '#cf1322');
        const scoreToneBg = score >= 80 ? '#f6ffed' : (score >= 50 ? '#fff7e6' : '#fff1f0');
        const scoreToneBorder = score >= 80 ? '#b7eb8f' : (score >= 50 ? '#ffe7ba' : '#ffccc7');
        const completed = scriptCheck.completed_stages || [];
        const missed = scriptCheck.missed_stages || [];
        const recs = scriptCheck.recommendations || [];

        return (
            <div>
                <div style={{
                    display: 'flex', gap: 20, alignItems: 'center', padding: '18px 20px', background: scoreToneBg, borderRadius: 12, border: `1px solid ${scoreToneBorder}`, marginBottom: 20,
                }}
                >
                    <div style={{
                        fontSize: 56, fontWeight: 700, color: scoreToneColor, lineHeight: 1, letterSpacing: -2,
                    }}
                    >
                        {score}
                        <span style={{ fontSize: 24, color: '#bfbfbf', fontWeight: 600 }}>/100</span>
                    </div>
                    <div>
                        <div style={{ fontWeight: 600 }}>
                            {scriptCheck.script_name ? `Скрипт «${scriptCheck.script_name}»` : 'Скрипт'}
                        </div>
                        <div style={{ fontSize: 13, color: '#6e6e73', marginTop: 4 }}>
                            Пройдено {completed.length} из {completed.length + missed.length} этапов
                        </div>
                        {scriptCheck.analysis && (
                            <div style={{
                                fontSize: 13, color: '#595959', marginTop: 8, lineHeight: 1.5,
                            }}
                            >
                                {scriptCheck.analysis}
                            </div>
                        )}
                    </div>
                </div>

                {completed.length > 0 && (
                    <>
                        <h3 style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#595959' }}>Пройденные этапы</h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px', marginBottom: 14 }}>
                            {completed.map((stg, i) => (
                                <div key={i} style={{ display: 'flex', gap: 10, padding: '7px 0', alignItems: 'center', fontSize: 13 }}>
                                    <CheckOutlined style={{ color: '#389e0d' }} />
                                    {stg}
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {missed.length > 0 && (
                    <>
                        <h3 style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#595959' }}>Пропущенные этапы</h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px', marginBottom: 14 }}>
                            {missed.map((stg, i) => (
                                <div key={i} style={{ display: 'flex', gap: 10, padding: '7px 0', alignItems: 'center', fontSize: 13 }}>
                                    <CloseOutlined style={{ color: '#cf1322' }} />
                                    {stg}
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {recs.length > 0 && (
                    <div style={{ background: '#f9fafb', padding: '14px 18px', borderRadius: 10, marginTop: 14 }}>
                        <h3 style={{ fontSize: 12, fontWeight: 600, marginBottom: 8, color: '#6e6e73', textTransform: 'uppercase', letterSpacing: 0.4 }}>
                            Рекомендации
                        </h3>
                        <ul style={{ paddingLeft: 18, fontSize: 13, color: '#595959', lineHeight: 1.7, margin: 0 }}>
                            {recs.map((r, i) => <li key={i} style={{ marginBottom: 4 }}>{r}</li>)}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    const renderDanger = () => (dangerIncidents.length > 0 ? (
        <div>
            {dangerIncidents.map((inc, idx) => {
                const isMedium = inc.severity === 'medium';
                return (
                    <div
                        key={idx}
                        style={{
                            padding: '14px 16px',
                            borderRadius: 12,
                            background: isMedium ? '#fffbeb' : '#fff5f5',
                            borderLeft: `3px solid ${isMedium ? '#fa8c16' : '#cf1322'}`,
                            marginBottom: 12,
                        }}
                    >
                        <div style={{
                            display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap',
                        }}
                        >
                            {inc.category && (
                                <Tag color={isMedium ? 'orange' : 'red'}>{inc.category}</Tag>
                            )}
                            {typeof inc.start === 'number' && (
                                <span style={{ fontSize: 11, color: '#999' }}>{formatSec(inc.start)}</span>
                            )}
                            {inc.speaker && (
                                <span style={{ fontSize: 11, color: '#999' }}>{inc.speaker}</span>
                            )}
                        </div>
                        {inc.quote && (
                            <div style={{
                                fontSize: 14, fontStyle: 'italic', padding: '10px 14px', background: '#fff', borderRadius: 8, margin: '8px 0 6px', color: '#333', lineHeight: 1.5,
                            }}
                            >
                                «{inc.quote}»
                            </div>
                        )}
                        {(inc.context || inc.recommendation || inc.description) && (
                            <div style={{ fontSize: 12, color: '#6e6e73', lineHeight: 1.5 }}>
                                {inc.description || inc.context || inc.recommendation}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    ) : <Empty description="Опасных моментов не обнаружено" />);

    const sectionRenderers = {
        brief: renderBrief,
        detailed: renderDetailed,
        transcript: renderTranscript,
        dia: renderDia,
        script: renderScript,
        danger: renderDanger,
    };

    const activeSection = SECTION_DEFS.find((s) => s.key === activeKey);

    return (
        <div>
            <div style={styles.header}>
                <div style={{
                    fontSize: 11, textTransform: 'uppercase', color: '#999', letterSpacing: 0.5, fontWeight: 600, marginBottom: 4,
                }}
                >
                    Тема разговора
                </div>
                <div style={styles.title}>{topic || 'Не определена'}</div>
                <div style={styles.meta}>
                    {record.ticket_number && (
                        <span>Талон <b style={{ color: '#1d1d1f' }}>№{record.ticket_number}</b></span>
                    )}
                    {record.user_fio && (
                        <span>Оператор <b style={{ color: '#1d1d1f' }}>{record.user_fio}</b></span>
                    )}
                    {record.queue_name && (
                        <span>Услуга <b style={{ color: '#1d1d1f' }}>{record.queue_name}</b></span>
                    )}
                    {record.close_data && (
                        <span>Дата <b style={{ color: '#1d1d1f' }}>{record.close_data}</b></span>
                    )}
                    {record.total_proc_time && (
                        <span>Длительность <b style={{ color: '#1d1d1f' }}>{record.total_proc_time}</b></span>
                    )}
                    <span>Оценка клиента{' '}
                        {record.ticket_mark > 0
                            ? <Rate disabled value={Number(record.ticket_mark)} style={{ fontSize: 14, verticalAlign: 'middle' }} />
                            : <Typography.Text type="secondary">не проставлена</Typography.Text>}
                    </span>
                </div>
                <div style={styles.statsGrid}>
                    <div style={styles.statCard}>
                        <div style={styles.statLabel}>Score по скрипту</div>
                        <div style={{
                            ...styles.statValue,
                            color: scriptCheck.script_used ? badgeTone.script === 'green' ? '#389e0d' : (badgeTone.script === 'orange' ? '#d46b08' : '#cf1322') : '#bfbfbf',
                        }}
                        >
                            {scriptCheck.script_used ? scriptCheck.score : '—'}
                            {scriptCheck.script_used && <span style={{ fontSize: 13, color: '#bfbfbf', fontWeight: 500 }}>/100</span>}
                        </div>
                    </div>
                    <div style={styles.statCard}>
                        <div style={styles.statLabel}>Опасные моменты</div>
                        <div style={{ ...styles.statValue, color: dangerCheck.danger_count > 0 ? '#cf1322' : '#1d1d1f' }}>
                            {dangerCheck.danger_count || 0}
                        </div>
                    </div>
                    <div style={styles.statCard}>
                        <div style={styles.statLabel}>Сегментов диалога</div>
                        <div style={styles.statValue}>{diaSegments.length || 0}</div>
                    </div>
                    <div style={styles.statCard}>
                        <div style={styles.statLabel}>Спикеров</div>
                        <div style={styles.statValue}>{meta.num_speakers || transcription.num_speakers || 0}</div>
                    </div>
                </div>
            </div>

            <div style={styles.audioBar}>
                <SoundOutlined style={{ color: '#1677ff', fontSize: 16 }} />
                <span style={styles.audioLabel}>Аудиозапись</span>
                <div style={{ flex: 1 }}>{parseAudio(record.audio)}</div>
            </div>

            <div style={styles.body}>
                <div style={styles.sidebar}>
                    {SECTION_DEFS.map((s) => {
                        const isActive = activeKey === s.key;
                        const badge = badges[s.key];
                        return (
                            <div
                                key={s.key}
                                role="button"
                                tabIndex={0}
                                onClick={() => setActiveKey(s.key)}
                                onKeyDown={(e) => { if (e.key === 'Enter') setActiveKey(s.key); }}
                                style={navItemStyle(s.key)}
                            >
                                <s.Icon style={{ fontSize: 15, width: 22, textAlign: 'center' }} />
                                <span style={{ flex: 1 }}>{s.label}</span>
                                {badge != null && (
                                    <span style={badgeStyle(s.key, isActive)}>{badge}</span>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div style={styles.content}>
                    <div style={styles.sectionTitle}>
                        <activeSection.Icon style={{ marginRight: 10, color: '#1677ff' }} />
                        {activeSection.label}
                    </div>
                    {sectionRenderers[activeKey]()}
                </div>
            </div>
        </div>
    );
}

function AudioRecord() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [playingAudio, setPlayingAudio] = useState(null);
    // Состояние для модального окна с распознанным текстом
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [recognitionData, setRecognitionData] = useState(null);
    const [activeRecord, setActiveRecord] = useState(null);
    const [processingAudio, setProcessingAudio] = useState(null);
    const [recognitionAvailable, setRecognitionAvailable] = useState(null);
    const [operators, setOperators] = useState([]);
    const [queues, setQueues] = useState([]);
    const initialFilters = {
        dateRange: null,
        ticketNumber: '',
        operatorId: null,
        queueId: null,
    };
    const [filters, setFilters] = useState(initialFilters);

    const applyFilters = () => {
        fetchData(filters);
    };

    const resetFilters = () => {
        setFilters(initialFilters);
        fetchData(initialFilters);
    };

    const checkRecognitionHealth = async () => {
        try {
            const resp = await axios.get('/api/audio-records-report/recognition/health');
            const available = !!resp.data && resp.data.available === true;
            setRecognitionAvailable(available);
            return available;
        } catch (e) {
            setRecognitionAvailable(false);
            return false;
        }
    };

    // Функция для воспроизведения аудио
    const playAudio = (audioUrl) => {
        // Если уже есть воспроизводимое аудио, остановить его
        if (playingAudio) {
            playingAudio.pause();
            if (playingAudio.src === audioUrl) {
                setPlayingAudio(null);
                return;
            }
        }

        // Создать новый аудио элемент
        const audio = new Audio(audioUrl);
        audio.play();
        audio.onended = () => {
            setPlayingAudio(null);
        };
        setPlayingAudio(audio);
    };

    // Функция для скачивания аудио
    const downloadAudio = (audioUrl, fileName) => {
        const link = document.createElement('a');
        link.href = audioUrl;
        link.download = fileName || 'audio-record.mp3';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Функция для форматирования длительности в минуты:секунды
    const formatDuration = (seconds) => {
        if (!seconds && seconds !== 0) return '-';
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    // Функция для форматирования даты
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('ru-RU');
    };

    // Определение колонок таблицы
    const columns = [
        {
            title: 'Дата закрытия талона',
            dataIndex: 'close_data',
            key: 'close_data',
            render: (text) => text || '-',
        },
        {
            title: 'Время обслуживания',
            dataIndex: 'total_proc_time',
            key: 'total_proc_time',
            render: (text) => text || '-',
        },
        {
            title: 'Номер талона',
            dataIndex: 'ticket_number',
            key: 'ticket_number',
            render: (text) => text || '-',
        },
        {
            title: 'Дата создания талона',
            dataIndex: 'create_data',
            key: 'create_data',
            render: (text) => text || '-',
        },
        {
            title: 'ФИО оператора',
            dataIndex: 'user_fio',
            key: 'user_fio',
            render: (text) => text || '-',
        },
        {
            title: 'Название очереди',
            dataIndex: 'queue_name',
            key: 'queue_name',
            render: (text) => text || '-',
        },
        {
            title: 'Оценка клиента',
            dataIndex: 'ticket_mark',
            key: 'ticket_mark',
            render: (mark) => (mark > 0
                ? <Rate disabled value={Number(mark)} />
                : <Typography.Text type="secondary">Оценка не проставлена</Typography.Text>),
        },
        {
            title: 'Аудио запись',
            dataIndex: 'audio',
            width: 320,
            render: (_, res) => {
                const { audio } = res;
                return (
                    <div style={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                    }}
                    >
                        {parseAudio(audio)}
                    </div>
                );
            },
        },
        {
            title: 'Распознавание речи',
            dataIndex: 'has_speech_recognition',
            key: 'speech_recognition',
            render: (text, record) => {
                if (!record.audio) {
                    return <Typography.Text type="secondary">Нет записей</Typography.Text>;
                }

                const audioPath = record.audio.split(',')[0];
                const status = record.recognition_status
                    || (record.has_speech_recognition ? 'done' : 'none');

                if (status === 'done') {
                    return (
                        <Button
                            type="primary"
                            icon={<SoundOutlined />}
                            onClick={() => getRecognizedText(record)}
                        >
                            Показать текст
                        </Button>
                    );
                }

                if (status === 'processing') {
                    return (
                        <div style={{ minWidth: 180 }}>
                            <Progress
                                percent={record.recognition_progress || 0}
                                status="active"
                                size="small"
                            />
                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                <LoadingOutlined /> {stageLabel(record.recognition_stage)}
                            </Typography.Text>
                        </div>
                    );
                }

                const isSubmitting = processingAudio === audioPath;
                const isDisabled = recognitionAvailable === false;
                return (
                    <Tooltip title={isDisabled ? 'Сервис распознавания недоступен' : ''}>
                        <Button
                            type="default"
                            icon={<CheckCircleOutlined />}
                            loading={isSubmitting}
                            disabled={isDisabled}
                            onClick={() => processAudioForRecognition(record.ticket_id, audioPath)}
                        >
                            Распознать
                        </Button>
                    </Tooltip>
                );
            },
        },
    ];

    // Функция для загрузки данных
    const fetchData = async (appliedFilters = initialFilters) => {
        setLoading(true);
        try {
            const token = window.localStorage.getItem('token');
            const params = { token };
            if (appliedFilters.dateRange && appliedFilters.dateRange[0]) {
                params.startDate = appliedFilters.dateRange[0].format('DD.MM.YYYY');
            }
            if (appliedFilters.dateRange && appliedFilters.dateRange[1]) {
                params.endDate = appliedFilters.dateRange[1].format('DD.MM.YYYY');
            }
            if (appliedFilters.ticketNumber) {
                params.ticketNumber = appliedFilters.ticketNumber;
            }
            if (appliedFilters.operatorId) {
                params.operatorId = appliedFilters.operatorId;
            }
            if (appliedFilters.queueId) {
                params.queueId = appliedFilters.queueId;
            }
            const response = await axios({
                method: 'get',
                url: '/api/audio-records-report',
                params,
            });

            // Добавляем отладочный вывод для проверки формата данных
            console.log('Ответ API:', response);
            console.log('Данные:', response.data);
            console.log('Тип данных:', typeof response.data, Array.isArray(response.data));

            // Проверяем разные варианты структуры данных
            if (response.data && Array.isArray(response.data)) {
                console.log('Используем массив из response.data');
                setData(response.data);
            } else if (response.data && response.data.records && Array.isArray(response.data.records)) {
                console.log('Используем массив из response.data.records');
                setData(response.data.records);
            } else if (response.data && typeof response.data === 'object') {
                // Если данные приходят в другом формате, пробуем найти массив в объекте
                const possibleArrays = Object.values(response.data).filter((value) => Array.isArray(value));
                if (possibleArrays.length > 0) {
                    console.log('Найден массив в объекте:', possibleArrays[0]);
                    setData(possibleArrays[0]);
                } else {
                    console.log('Не найдено массивов в объекте');
                    setData([]);
                    message.warning('Нет данных для отображения');
                }
            } else {
                console.log('Не удалось обработать данные');
                setData([]);
                message.warning('Нет данных для отображения');
            }
        } catch (error) {
            message.error('Ошибка при загрузке данных аудиозаписей');
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    // Функция для обработки аудиофайла через распознавание речи
    const processAudioForRecognition = async (ticketId, audioPath) => {
        setProcessingAudio(audioPath);
        try {
            const available = await checkRecognitionHealth();
            if (!available) {
                message.warning('Сервис распознавания недоступен');
                return;
            }
            const token = window.localStorage.getItem('token');
            const response = await axios({
                method: 'post',
                url: '/api/audio-records-report/recognition/process-file',
                data: {
                    ticketId,
                    audioPath,
                    token,
                },
            });

            if (response.data && response.data.success) {
                message.success('Файл отправлен на распознавание');
                // Оптимистично помечаем строку как обрабатываемую, чтобы UI сразу отреагировал
                setData((prev) => prev.map((row) => (row.ticket_id === ticketId
                    ? {
                        ...row,
                        recognition_status: 'processing',
                        recognition_progress: 0,
                        recognition_stage: 'queued',
                    }
                    : row)));
            } else {
                message.error('Ошибка при отправке файла на распознавание');
            }
        } catch (error) {
            console.error('Ошибка при обработке аудиофайла:', error);
            message.error('Ошибка при обработке аудиофайла');
        } finally {
            setProcessingAudio(null);
        }
    };

    // Функция для получения распознанного текста
    const getRecognizedText = async (record) => {
        try {
            const token = window.localStorage.getItem('token');
            const response = await axios({
                method: 'get',
                url: `/api/audio-records-report/recognition/${record.ticket_id}`,
                params: { token },
            });

            if (response.data.data && response.data.success) {
                setRecognitionData(response.data.data);
                setActiveRecord(record);
                setIsModalVisible(true);
            } else {
                message.error('Текст распознавания не найден');
            }
        } catch (error) {
            console.error('Ошибка при получении распознанного текста:', error);
            message.error('Ошибка при получении распознанного текста');
        }
    };

    useEffect(() => {
        fetchData();
        checkRecognitionHealth();

        (async () => {
            try {
                const resp = await axios.get('/api/queueobjects/');
                const d = resp.data || {};
                setQueues(Array.isArray(d.queues) ? d.queues : []);
                setOperators(Array.isArray(d.users) ? d.users : []);
            } catch (e) {
                // список не критичен — оставляем пустым
            }
        })();

        return () => {
            if (playingAudio) {
                playingAudio.pause();
            }
        };
    }, []);

    // Пока есть записи в обработке — тихо поллим лёгкий статусный эндпоинт
    // и мёржим изменения в уже загруженные строки (без мигания таблицы)
    useEffect(() => {
        const processingIds = data
            .filter((r) => r.recognition_status === 'processing')
            .map((r) => r.ticket_id);
        if (processingIds.length === 0) return undefined;

        const token = window.localStorage.getItem('token');
        const tick = async () => {
            try {
                const resp = await axios.get('/api/audio-records-report/recognition/statuses', {
                    params: { token, ids: processingIds.join(',') },
                });
                const statuses = resp.data || {};
                setData((prev) => prev.map((row) => {
                    const st = statuses[row.ticket_id];
                    if (!st) return row;
                    const nextStatus = st.status || row.recognition_status;
                    const nextProgress = st.progress ?? row.recognition_progress;
                    const nextStage = st.stage ?? row.recognition_stage;
                    // Не пересоздаём объект, если ничего не изменилось
                    if (
                        row.recognition_status === nextStatus
                        && row.recognition_progress === nextProgress
                        && row.recognition_stage === nextStage
                        && !(nextStatus === 'done' && !row.has_speech_recognition)
                    ) {
                        return row;
                    }
                    return {
                        ...row,
                        recognition_status: nextStatus,
                        recognition_progress: nextProgress,
                        recognition_stage: nextStage,
                        has_speech_recognition: nextStatus === 'done' ? true : row.has_speech_recognition,
                    };
                }));
            } catch (e) {
                // Тихо игнорируем — следующий тик попробует снова
            }
        };
        const id = setInterval(tick, 2000);
        return () => clearInterval(id);
    }, [data]);

    return (
        <div className="audio-records-container" style={{ marginTop: 24 }}>
            {/* <h2>Отчет по аудиозаписям</h2> */}
            {recognitionAvailable === false && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message="Сервис распознавания речи недоступен"
                    description="Запустите сервер распознавания, чтобы отправлять новые записи. Уже распознанные записи доступны для просмотра."
                    action={(
                        <Button size="small" onClick={checkRecognitionHealth}>
                            Проверить
                        </Button>
                    )}
                />
            )}
            <Space style={{ marginBottom: 16, flexWrap: 'wrap' }}>
                <DatePicker.RangePicker
                    format="DD.MM.YYYY"
                    placeholder={['С', 'По']}
                    value={filters.dateRange}
                    onChange={(v) => setFilters((f) => ({ ...f, dateRange: v }))}
                />
                <Input
                    allowClear
                    placeholder="Номер талона"
                    style={{ width: 180 }}
                    value={filters.ticketNumber}
                    onChange={(e) => setFilters((f) => ({ ...f, ticketNumber: e.target.value }))}
                />
                <Select
                    showSearch
                    allowClear
                    placeholder="Оператор"
                    style={{ width: 220 }}
                    value={filters.operatorId}
                    onChange={(v) => setFilters((f) => ({ ...f, operatorId: v || null }))}
                    optionFilterProp="children"
                    options={operators.map((o) => ({ value: o.id, label: o.fio || o.username || o.name }))}
                />
                <Select
                    showSearch
                    allowClear
                    placeholder="Услуга"
                    style={{ width: 220 }}
                    value={filters.queueId}
                    onChange={(v) => setFilters((f) => ({ ...f, queueId: v || null }))}
                    optionFilterProp="children"
                    options={queues.map((q) => ({ value: q.id, label: q.fullname || q.name }))}
                />
                <Button type="primary" onClick={applyFilters}>Применить</Button>
                <Button onClick={resetFilters}>Сбросить</Button>
            </Space>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="ticket_id"
                loading={loading}
                bordered
            />

            <Modal
                title={null}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={1200}
                bodyStyle={{ padding: 0 }}
            >
                {recognitionData && activeRecord ? (
                    <RecognitionReport data={recognitionData} record={activeRecord} />
                ) : (
                    <Typography.Paragraph>Данные не загружены</Typography.Paragraph>
                )}
            </Modal>
        </div>
    );
}

export default AudioRecord;



